export const useCheckoutDisabled = () => useState<boolean>('checkoutDisabled', () => false);
